import { useState, useEffect } from 'react'
import { validateTitle, type TitleValidationResult } from '@/lib/amazon-title-validator'

interface UseAmazonTitleValidatorReturn {
  results: TitleValidationResult[]
  titleCount: number
}

export function useAmazonTitleValidator(
  rawInput: string,
  forbiddenWords: string[]
): UseAmazonTitleValidatorReturn {
  const [results, setResults] = useState<TitleValidationResult[]>([])

  useEffect(() => {
    const timer = setTimeout(() => {
      const titles = rawInput
        .split('\n')
        .map((t) => t.trim())
        .filter((t) => t.length > 0)
      setResults(titles.map((t) => validateTitle(t, forbiddenWords)))
    }, 300)
    return () => clearTimeout(timer)
  }, [rawInput, forbiddenWords])

  return { results, titleCount: results.length }
}
